'use client'

import { useState, useEffect, useRef } from 'react'
import { useRouter } from 'next/navigation'
import { useSearch } from './search-provider'
import { SearchInput } from './search-input'
import { SearchRecent, addRecentSearch } from './search-recent'
import { SearchTypeahead } from './search-typeahead'

export function SearchModal() {
  const { isOpen, close } = useSearch()
  const [query, setQuery] = useState('')
  const backdropRef = useRef<HTMLDivElement>(null)
  const router = useRouter()

  // Reset query when modal opens
  useEffect(() => {
    if (isOpen) setQuery('')
  }, [isOpen])

  // Lock body scroll when open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
    return () => {
      document.body.style.overflow = ''
    }
  }, [isOpen])

  if (!isOpen) return null

  const handleSubmit = () => {
    if (query.trim().length < 2) return
    addRecentSearch(query)
    router.push(`/search?q=${encodeURIComponent(query.trim())}`)
    close()
  }

  return (
    <div
      ref={backdropRef}
      className="fixed inset-0 z-50 flex items-start justify-center bg-black/50 pt-[15vh] backdrop-blur-sm"
      onClick={(e) => {
        if (e.target === backdropRef.current) close()
      }}
      role="dialog"
      aria-modal="true"
      aria-label="Search"
    >
      <div className="w-full max-w-xl rounded-2xl border border-[var(--color-border-default)] bg-[var(--color-bg-surface)] shadow-2xl">
        <div className="p-4">
          <SearchInput
            value={query}
            onChange={setQuery}
            onSubmit={handleSubmit}
          />
        </div>

        {query.trim().length >= 2 ? (
          <SearchTypeahead query={query} />
        ) : (
          <SearchRecent onSelect={(q) => setQuery(q)} />
        )}
      </div>
    </div>
  )
}
